import { memo } from 'react';
import { Close } from '@mui/icons-material';
import { IconButton, Typography, Box, styled } from '@mui/material';
import { useDispatch } from 'react-redux';

import { setDrawer } from 'store/entities/drawer/actions';

const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 16,
});
interface Props {
  title: string;
}

export const DrawerHeader = memo(({ title }: Props) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(
      setDrawer({
        isOpen: false,
        contentType: null,
        dataSchema: null,
        entity: '',
      })
    );
  };

  return (
    <Header>
      <Typography variant="h5">{title}</Typography>
      <IconButton onClick={handleClose} size="small">
        <Close />
      </IconButton>
    </Header>
  );
});
